import {Space, Tooltip} from 'antd';
import {ReloadOutlined} from '@ant-design/icons';
import styles from './index.module.scss';
import React, {useContext} from 'react';
import SelectableMenu from '../SelectableMenu';
import {ProTableContext} from '../../context';
import Spacer from '../../../Spacer';

export interface OptionsType {
    density?: boolean; // 表格大小
    reload?: boolean; // 刷新数据
    setting?: boolean; // 设置列
}

interface ToolBarProps {
    options: OptionsType | false; // false表示不显示默认工具
    toolBar?: React.ReactNode; // toolbar自定义
}

export default function ToolBar({options, toolBar}: ToolBarProps) {
    const {size, setSize} = useContext(ProTableContext);

    return (
        <div className={styles.root}>
            {toolBar}

            <Spacer />

            <Space>
                {options && options.reload && (
                    <Tooltip title="刷新">
                        <div className={styles.btn}>
                            <ReloadOutlined />
                        </div>
                    </Tooltip>
                )}

                {options && options.density && (
                    <SelectableMenu size={size} onChange={setSize} />
                )}
            </Space>
        </div>
    );
}
